export default __webpack_public_path__ + "static/lightning_w.d95af7a75a16e8cc0b5686653b5f3a5a.png";